"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-73cd94d2"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
    key: 0,
    class: "bg-white cursor-default text-center p-2 border-t border-gray hover:bg-gray"
};
const debounce_1 = __importDefault(require("lodash/debounce"));
const vue_3 = require("vue");
const ShopInput_vue_1 = __importDefault(require("../ShopInput.vue"));
const validators_1 = require("../../../common/utils/validators");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AsyncSearchInput',
    props: {
        placeholder: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        displayValue: {
            type: String,
            default: "",
        },
        required: Boolean,
        maxLength: {
            type: Number,
            required: false,
        },
        customClass: {
            type: String,
            required: false,
            default: "",
        },
        debounceInMs: {
            type: Number,
            default: 300,
        },
        displayValueAfterSelection: {
            type: Boolean,
            default: false,
            required: false,
        },
        showValidity: {
            type: Boolean,
            default: false,
        },
        invalidMessage: {
            type: String,
            required: false,
            default: "",
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    emits: ["searchedValueChanged", "selected"],
    setup(__props, { expose, emit }) {
        var _a;
        const props = __props;
        const displayValue = (0, vue_3.ref)(props.displayValue);
        const searchVisible = (0, vue_3.ref)(false);
        const componentId = (_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid;
        const activeOptionIndex = (0, vue_3.ref)(-1);
        const selectedValue = (0, vue_3.ref)(displayValue.value);
        let searcher = null;
        let searcherInput = null;
        const openSearcher = () => {
            searchVisible.value = true;
            selectedValue.value = displayValue.value;
            (0, vue_3.nextTick)(() => {
                searcherInput = document.getElementById(`searcher_input_${componentId}`);
                if (searcherInput === null) {
                    return;
                }
                searcherInput.focus();
            });
        };
        const clickOutsideListener = (event) => {
            if (searcher !== null && !searcher.contains(event.target)) {
                searchVisible.value = false;
                return;
            }
        };
        (0, vue_3.onMounted)(() => {
            searcher = document.getElementById(`searcher_${componentId}`);
            document.addEventListener("click", clickOutsideListener);
        });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener("click", clickOutsideListener);
        });
        const onInputBlur = () => {
            if (selectedValue.value !== displayValue.value) {
                displayValue.value = "";
            }
        };
        (0, vue_3.watch)(displayValue, (0, debounce_1.default)((value) => {
            if (value === "") {
                return;
            }
            emit("searchedValueChanged", displayValue.value);
        }, props.debounceInMs));
        const itemSelected = (item) => {
            displayValue.value = props.displayValueAfterSelection
                ? item.value
                : item.label;
            selectedValue.value = displayValue.value;
            emit("selected", item);
        };
        const setDisplayValue = (value) => {
            displayValue.value = value;
        };
        const searcherKeydown = (event) => {
            if (event.key === "Tab") {
                searchVisible.value = false;
            }
            else if (event.key === "ArrowDown") {
                navigateOptions(1);
            }
            else if (event.key === "ArrowUp") {
                navigateOptions(-1);
            }
            else if (event.key === "Enter") {
                event.preventDefault();
            }
        };
        const selectOption = () => {
            if (activeOptionIndex.value !== -1) {
                itemSelected(props.options[activeOptionIndex.value]);
                searchVisible.value = false;
            }
        };
        const navigateOptions = (step) => {
            const newIndex = activeOptionIndex.value + step;
            if (newIndex >= 0 && newIndex < props.options.length) {
                activeOptionIndex.value = newIndex;
            }
        };
        expose({ setDisplayValue });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `searcher_${(0, vue_2.unref)(componentId)}`,
                class: "relative w-full"
            }, [
                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                    id: `searcher_input_${(0, vue_2.unref)(componentId)}`,
                    modelValue: displayValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((displayValue).value = $event)),
                    type: "text",
                    placeholder: __props.placeholder,
                    label: __props.label,
                    autocomplete: false,
                    border: "",
                    required: __props.required,
                    "max-length": __props.maxLength,
                    "show-validity": __props.showValidity,
                    valid: !(0, vue_2.unref)(validators_1.isBlank)(displayValue.value),
                    "invalid-message": __props.invalidMessage,
                    icon: "marso-icon-search",
                    onFocusin: openSearcher,
                    onKeydown: searcherKeydown,
                    onKeyup: (0, vue_2.withKeys)(selectOption, ["enter"]),
                    onFocusout: onInputBlur
                }, null, 8, ["id", "modelValue", "placeholder", "label", "required", "max-length", "show-validity", "valid", "invalid-message", "onKeyup"]),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("ul", {
                    class: (0, vue_2.normalizeClass)(["absolute left-0 z-10 w-full bg-white block shadow-sm", __props.customClass])
                }, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.options.slice(0, 5), (option, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: index }, [
                            (__props.options)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                    key: 0,
                                    class: (0, vue_2.normalizeClass)(["p-2 hover:bg-gray cursor-pointer", { active: activeOptionIndex.value === index }]),
                                    onClick: ($event) => (itemSelected(option))
                                }, (0, vue_2.toDisplayString)(option.label), 11, _hoisted_2))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 64));
                    }), 128)),
                    (__props.options.length > 5)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_3, " ... "))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 2), [
                    [vue_2.vShow, searchVisible.value]
                ])
            ], 8, _hoisted_1));
        };
    }
});
